import {BaseModel, BaseListModel, ApiList, apiClient, ApiDetail} from "../lib/model";

export class CardStatus extends BaseModel {
    id;
    lastSeen;
    firstSeen;
    streakCount;
    longCount;
    longCorrect;
    seenCount;
    correctCount;
    seenToday;
    level;

    constructor(data) {
        super();
        this.api.url = '/card-status/';
        this.api.dateFields = ['lastSeen', 'firstSeen'];
        if (data instanceof Object) {
            this.modelCopy(data);
        }
    }
}

export class Card extends BaseModel {
    id;
    front;
    lang;
    back;
    backLang;
    status;
    createdBy;
    createdDate;
    modifiedBy;
    modifiedDate;

    api = new class extends ApiDetail {
        url = '/card/:pk/';
        dateFields = ['createdDate', 'modifiedDate'];
        updateFields = ['front', 'lang', 'back', 'backLang'];

        mark(correct, easy, stackId) {
            return apiClient().patch(
                this.getUrl(this.parent.id, '/card/:pk/mark/'),
                {
                    correct: correct,
                    easy: easy,
                    stack_id: stackId,
                }
            );
        }
    }(this);

    constructor(data) {
        super();
        this.modelCopy(data);
    }
    modelCopy(data) {
        super.modelCopy(data);
        if (data instanceof Object) {
            if (data.hasOwnProperty('status'))
                this.status = new CardStatus(data.status);

            if (this.hasOwnProperty('id') && data.id)
                this.id = data.id;
        }
    }
}

export class CardList extends BaseListModel {
    api = new class extends ApiList {
        url = '/stack/:pk/cards/';

    }(this);
    constructor(cards) {
        super();
        if (cards instanceof Array) {
            this.modelCopy(cards);
        }
    }
    pushItem(item) {
        super.pushItem(new Card(item));
    }
}


export function test () {
    let t = new CardStatus({
        one: 'one',
        two: 'two',
        three: 'three',
        last_seen: '2010-01-20',
        final_card_count: 3,
    });
    // eslint-disable-next-line no-console
    console.log(t)
}
